import React from "react";
import { FC } from "react";
import { ProfessionalData } from "../../../../models";
import Typography from "../../../../components/Typography";

const buttonStyle = (selected: boolean): React.CSSProperties => ({
    width: '100%',
    padding: 'var(--spacer-S)',
    gap: 'var(--spacer-S)',
    display: 'flex',
    flexDirection: 'row',
    borderStyle: 'solid',
    borderRadius: '5px',
    borderColor: selected ? 'var(--green)' : 'lightgray',
    borderWidth: '2px',
    cursor: 'pointer',
})

const detailsStyle = (): React.CSSProperties => ({
    display: 'flex', 
    flexDirection: 'column',
    gap: 'var(--spacer-S)',
    overflow: 'hidden',
})

export const ProfessionalSelector: FC<{
    options: ProfessionalData[]
    value: ProfessionalData | undefined
    onUpdate: (value?: ProfessionalData) => void
}> = ({
    options,
    value,
    onUpdate,
}) => {
    return (
        <div style={{display: 'flex', gap: 'var(--spacer-XS)', flexDirection: 'column'}}>
            {options.map(professional => (
                <div 
                    key={professional.id}
                    style={buttonStyle(value?.id === professional.id)}
                    onClick={() => onUpdate(value?.id === professional.id ? undefined : professional)}
                >
                    {!!professional?.photoUrl &&
                        <div>
                            <img alt='' style={{
                                maxHeight: value?.id === professional.id ? '300px' : '100px',
                                maxWidth: '200px',
                                transition: 'max-height 0.25s ease-in, max-height 0.15s ease-out',
                            }} src={professional.photoUrl}/>
                        </div>
                    }
                    <div style={detailsStyle()}>
                        <Typography size="large">{professional.name}</Typography>
                        
                        <Typography style={{
                            whiteSpace: 'pre-line', 
                            maxHeight: value?.id === professional.id ? '300px' : '80px', 
                            overflow: 'hidden',
                            transition: 'max-height 0.25s ease-in, max-height 0.15s ease-out',
                        }}>
                            {professional.biography}
                        </Typography>
                    </div>
                </div>
            ))}
        </div>
    )
}
